import { CsvColumn } from './CsvColumn';

export class CsvSpecification {
  header?: string;
  columns: CsvColumn[] = [];

  constructor(opts?: Partial<CsvSpecification>) {
    if (opts?.header != null) {
      this.header = opts.header;
    }
    if (opts?.columns != null) {
      this.columns = [...opts.columns];
    }
  }
}
